export type TenantProvisioningContextType = {
    businessName: string;
    vanityURL: string;
    setBusinessName: (businessName: string) => void;
    setVanityURL: (vanityURL: string) => void;
};

export const TenantProvisioningContextDefaultValues: TenantProvisioningContextType =
    {
        businessName: '',
        vanityURL: '',
        // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
        setBusinessName: () => {},
        // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
        setVanityURL: () => {},
    };
